import { useCallback, useEffect, useState } from 'react'

export type TUseRequestReturn<T> = {
  data: T | null
  error: unknown
  success: boolean
  isLoading: boolean
}
export type TUseRequest<T> = (args: any) => Promise<T>
export const useRequest = <T>(
  requestData: TUseRequest<T>,
  params?: any
): TUseRequestReturn<T> => {
  const [data, setData] = useState<T | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [success, setSuccess] = useState<boolean>(false)
  const [error, setError] = useState<unknown>(null)

  const request = useCallback(async () => {
    setError(null)
    setSuccess(false)
    setIsLoading(true)

    try {
      const response = await requestData(params)
      setData(response)
      setSuccess(true)
    } catch (e) {
      setSuccess(false)
      setError(e)
    } finally {
      setIsLoading(false)
    }
  }, [params, requestData])

  useEffect(() => {
    request()
  }, [request])

  return {
    data,
    error,
    success,
    isLoading,
  }
}
